module.exports = __webpack_public_path__ + "img/marker-oil-export-green.b1531e20.png";